export enum SERVICE_INPUT_KEYS {
    //NOTE: needs to match backend keys
    CONTACT_NUMBER = 'contactNumber',
    SIM_NUMBER = 'slideNumber',
    IDENTIFICATION_NUMBER = 'identificationNumber',
    RECHARGE_NUMBER = 'rechargeNumber',
    DEVICE_NUMBER = 'deviceNumber',
    START_DATE = 'startDate',
    END_DATE = 'endDate',
    START_TIME = 'startTime',
    END_TIME = 'endTime',
    ACCOUNT_NUMBER = 'accountNumber',
    TOWER_NUMBER = 'towerNumber',
    COORDINATES = 'coordinates',
    CAB_NUMBER = 'cabNumber',
    CIRCUIT_NUMBER = 'circuitNumber',
    MODEM_NUMBER = 'modemNumber',
    IP_ADDRESS = 'ipAddress',
    PLAT_INFO = 'plateInfo',
    SLIDE_NUMBER = 'slideNumber',
    CUSTOMER_NAME = 'customerName',
    CUSTOMER_ID = 'customerId'


}
